// @flow

import React, { Component } from 'react'
import { observer } from 'mobx-react'

import CircularProgress from '@material-ui/core/CircularProgress'
import SettingsModel from 'src/Models/Admin/Settings/SettingsModel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'

type Props = { userId: string }

@observer
class MenuComponent extends Component {
  settingsModel: SettingsModel

  constructor(props: Props) {
    super(props)

    this.settingsModel = new SettingsModel()
  }

  componentDidMount() {
    if (this.settingsModel) this.settingsModel.update(this.props.userId)
  }

  render() {
    if (!this.settingsModel || !this.settingsModel.isLoaded) {
      return <CircularProgress />
    }

    const styles = {
      block: {
        maxWidth: 310,
      },
    }

    return (
      <div>
        <div style={styles.block}>
          <FormControlLabel
            label="Show all app modules"
            control={
              <Switch
                color="primary"
                checked={this.settingsModel.hasMenu}
                onChange={(event, value) =>
                  (this.settingsModel.hasMenu = value)
                }
              />
            }
          />
        </div>
      </div>
    )
  }
}

export default MenuComponent
